module.exports = __webpack_public_path__ + "img/profilo_smartbook.cbd18440.png";